import '../../assets/components/VisuallyHidden/visuallyhidden.css';const s = "_visuallyHidden_473bs_1", l = {
  visuallyHidden: s
};
export {
  l as default,
  s as visuallyHidden
};
